import { BasePublicApi } from '#packages/apilib';

import type { AiScope as Scope } from './scope';

export class AiPublicApi extends BasePublicApi<Scope> {}
